<app-modal-dialog
  [header]="'Delete period &nbsp;'"
  [showWhiteSpace]="false"
  [useStandardList]="true"
  (isConfirmed)="confirm($event)">
  <ng-container *ngIf="periodHasReport">
    <div class="pd-top-0p5">
      <div class="bg-color-orange-2-opacity-0p3 br-0p5 border-orange-10 padding-0p5 centered-row-container row-gap-0p5">
        <app-all-icons class="orange-10 icon-size-1p25" [iconNameAndStyling]="'exclamation.svg'"></app-all-icons>
        <span class="font-3 orange-10">
          This period has shared investor<br>report that will be deleted too.
        </span>
      </div>
    </div>
    <div class="whitespace-1"></div>
  </ng-container>
</app-modal-dialog>
